import React, { useState, useEffect } from 'react'
import { Card} from '@shopify/polaris'
import { Pagination, Input, Spin, Select, Modal, message} from "antd"
import 'antd/dist/antd.css'
import tracking_status from "../static/statuses"
import { getExportTracking, cancelExportTracking, retryExportTracking, deleteExportTracking } from '../../../services/api/TrackingMappingServices'
import ExportTrackingUpload from './ExportTrackingUpload'
import ExportTrackingTable from './ExportTrackingTable'


const ExportTracking = () => {

    const [tracking, setTracking] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(50)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('')
    const [trackingStatus, setTrackingStatus] = useState('')

    const _handleChangePagination = (page, pageSize) => {
        setPage(pageSize !== limit ? 1 : page)
        setLimit(pageSize)
    }

    const _onSearch = query => {
        setSearch(query)
        setPage(1)
    }

    const _handleChangeStatuses = status => {
        setTrackingStatus(status)
        setPage(1)
    }

    const fetchListTracking = async () => {
        setLoading(true)
        setError('')
        setTracking([])

        try {

            const payload = {
                page, limit
            }

            if(search) payload.file_name = search
            if(trackingStatus) payload.status = trackingStatus

            const response = await getExportTracking(payload)
            const { success, data, message } = response

            if (!success) {
                setLoading(false)
                setError(message)
            }

            setTracking(data.exportTrackings)
            setTotal(data.total)
            // setLocationOptions(locationOptions)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _cancelAction = async (id) => {
        try {
            const response = await cancelExportTracking(id)
            const { message: mess, success } = response
            if (!success) return message.error(`${mess}!`)
            message.success('Cancel successfully!')
            fetchListTracking()
        } catch (e) {
            message.error(e.message || 'Unknown error.')
        }
    }

    const handleClickCancel = (e, id) => {
        e.preventDefault()
        Modal.confirm({
            title: 'Confirm Cancel',
            icon: '',
            content: 'Are you sure you want to cancel?',
            okText: 'Ok',
            cancelText: 'Cancel',
            onOk: () => _cancelAction(id)
        })
    }

    const _retryAction = async (id) => {
        try {
            const response = await retryExportTracking(id)
            const { message: mess, success } = response
            if (!success) return message.error(`${mess}!`)
            message.success('Retry successfully!')
            fetchListTracking()
        } catch (e) {
            message.error(e.message || 'Unknown error.')
        }
    }

    const handleClickRetry = (e, id) => {
        e.preventDefault()
        Modal.confirm({
            title: 'Confirm Retry',
            icon: '',
            content: 'Are you sure you want to retry?',
            okText: 'Ok',
            cancelText: 'Cancel',
            onOk: () => _retryAction(id)
        })
    }

    const _deleteAction = async (id) => {
        try {
            const response = await deleteExportTracking(id)
            const { message: mess, success } = response
            if (!success) return message.error(`${mess}!`)
            message.success('Delete successfully!')
            fetchListTracking()
        } catch (e) {
            message.error(e.message || 'Unknown error.')
        }
    }

    const handleClickDelete = (e, id) => {
        e.preventDefault()
        Modal.confirm({
            title: 'Confirm Delete',
            icon: '',
            content: 'Are you sure you want to delete?',
            okText: 'Ok',
            cancelText: 'Cancel',
            onOk: () => _deleteAction(id)
        })
    }

    useEffect(() => {
        fetchListTracking()
    }, [page, limit, trackingStatus, search])

    return (
        <React.Fragment>
            <ExportTrackingUpload refreshExportTracking={fetchListTracking}/>
            <div className="TrackingMapping TrackingMappingV2">
                <Spin spinning={loading} tip="Getting list  tracking...">
                    <Card sectioned>
                        <Card.Subsection>
                            <div className="TrackingFilter">
                                <div className="TrackingSearch">
                                    <Input.Search
                                        placeholder="Find by File name"
                                        onChange={(e) =>
                                            _onSearch(e.target.value)
                                        }
                                        value={search}
                                        style={{width: '250px'}}
                                        allowClear
                                    />
                                </div>
                                <div className="ListFilter">
                                    <div className="TrackingStatuses">
                                        <div className="Filters">
                                            <label htmlFor="status">
                                                Status
                                            </label>
                                            <Select
                                                value={trackingStatus || undefined}
                                                onChange={_handleChangeStatuses}
                                                // mode="multiple"
                                                maxTagCount="3"
                                                optionLabelProp="label"
                                                // defaultValue={trackingStatus}
                                                placeholder="Select Tracking Status"
                                                allowClear
                                                options={tracking_status}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card.Subsection>
                        <Card.Subsection>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>File name</th>
                                        <th>Status</th>
                                        <th>Created at</th>
                                        <th>Completed at</th>
                                        <th>Processing at</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!!tracking &&
                                        tracking.length > 0 &&
                                        tracking.map((item, index) => (
                                            <ExportTrackingTable
                                                key={index}
                                                index={index}
                                                item={item}
                                                handleClickCancel={handleClickCancel}
                                                handleClickRetry={handleClickRetry}
                                                handleClickDelete={handleClickDelete}
                                                refreshTracking={fetchListTracking}
                                            />
                                        ))}

                                    {!!error && error.length > 0 && (
                                        <tr>
                                            <td
                                                style={{color: 'red'}}
                                                colSpan={4}
                                            >
                                                {error}
                                            </td>
                                        </tr>
                                    )}

                                    {!!tracking && tracking.length === 0 && (
                                        <tr>
                                            <td colSpan={4}>No record</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Card.Subsection>
                        <Card.Subsection>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                onChange={_handleChangePagination}
                                className="text-right"
                                showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                            />
                        </Card.Subsection>
                    </Card>
                </Spin>
            </div>
        </React.Fragment>
    )
}

export default ExportTracking